import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as AuthActions from '../auth/AuthActions';
import api from '../api';
import LoginCard from '../components/LoginCard';
import GoogleSignInButton from '../components/GoogleSignInButton';

const ERROR_MESSAGES = {
    unauthorised_domain: "That Google account is not permitted to sign in here.",
    unknown_user: "No account exists for that Google email.",
    invalid_state: "Sign-in expired. Please try again.",
    oauth_failed: "Google sign-in failed. Please try again.",
    access_denied: "Sign-in was cancelled.",
};

@connect(state => ({ auth: state.auth }))
export default class GoogleHandoffContainer extends Component {
    render() {
        return (
            <GoogleHandoff
                {...bindActionCreators(AuthActions, this.props.dispatch)} />
        );
    }
}

class GoogleHandoff extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    componentDidMount() {
        const params = new URLSearchParams(window.location.hash.slice(1));
        const token = params.get('token');
        const error = params.get('error');

        // Strip the fragment so the token doesn't sit in the URL bar.
        window.history.replaceState(null, '', window.location.pathname);

        if (error) {
            this.setState({ error: ERROR_MESSAGES[error] || `Sign-in error: ${error}` });
            return;
        }

        if (!token) {
            this.setState({ error: "Missing sign-in token. Please try again." });
            return;
        }

        localStorage.setItem('token', token);

        api.get('me')
            .then(response => {
                this.props.login(response.value.user, token);
                window.location = '/';
            })
            .catch(err => {
                localStorage.removeItem('token');
                this.setState({ error: err.toString() });
            });
    }

    render() {
        if (this.state.error) {
            return (
                <LoginCard>
                    <div className="alert alert-danger"><strong>{this.state.error}</strong></div>
                    <GoogleSignInButton>Try again</GoogleSignInButton>
                </LoginCard>
            );
        }

        return (
            <LoginCard>
                <p className="login-status"><i className="fa fa-circle-o-notch fa-spin"></i>Signing you in&hellip;</p>
            </LoginCard>
        );
    }
}



// WEBPACK FOOTER //
// ./app/pages/GoogleHandoff.js